export default class VideoPopup {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $( document ).ready(function() {
            $('.video-popup, .wistia-video:not(.wistia-container__video)').on('click', function (e){
                e.preventDefault();
                let video = $(this).attr('data-src');
                if(video){

                    if (video.includes('youtube.com') || video.includes('youtu.be')) {
                        let youtubeId = video.split('v=')[1]?.split('&')[0] || video.split('/').pop();

                        let params = video.split('v=')[1]?.split('&').slice(1).join('&') || "";

                        let embedUrl = `https://www.youtube.com/embed/${youtubeId}`;
                        if (params) {
                            embedUrl += `?${params}`;
                        }

                        video = embedUrl;
                    }else if (video.includes('info.duckcreek.com')) {} else {
                        video = 'https://fast.wistia.net/embed/iframe/' + (video.split('medias/')[1] || video.split('medias/')[0]);
                    }
                    $('.popup-wistia').addClass('active');
                    $('.popup-wistia__iframe').html('<iframe class="mfp-iframe" src="' + video + '" frameborder="0" allowfullscreen></iframe>');
                }
            })

            $('.popup-wistia__exit, .popup-wistia .rgba').on('click', function (e){
                e.preventDefault();
                $('.popup-wistia').removeClass('active');
                $('.popup-wistia__iframe').html('');
            })
        })
    }

}